import { render, staticRenderFns } from "./MassMessageStatItem.vue?vue&type=template&id=0b5fea6d&scoped=true&"
import script from "./MassMessageStatItem.vue?vue&type=script&lang=ts&"
export * from "./MassMessageStatItem.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageStatItem.vue?vue&type=style&index=0&id=0b5fea6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5fea6d",
  null
  
)

export default component.exports